<template>
  <div>
    <div class="row no-margin">
      <h5 class="overview-h5">{{ $t(pageTitle) }} </h5>
      <small class="clear-filter" style="height: 24px; margin-top: 16px;" v-if="hasActiveFilters" v-on:click="resetAll()">{{ $t('clear_filter') }}</small>
    </div>

    <div class="row" style="text-align: left;">
      <div class="col-sm-4" v-for="filter in filterItems" v-bind:key="filter.id">
        <div class="form-group row">
          <template v-if="filter.type === 'dateRange'">
            <label :for="filter.id" class="col-sm-6 col-form-label col-form-label-sm">{{ filter.label || $t(filter.id) }}</label>
            <date-range-filter v-bind:filter="filter" @toggle-value="handleFilterChange" />
          </template>

          <template v-else-if="filter.type === 'date'">
            <label :for="filter.id" class="col-sm-6 col-form-label col-form-label-sm">{{ filter.label || $t(filter.id) }}</label>
            <date-filter v-bind:filter="filter" @toggle-value="handleFilterChange" />
          </template>

          <template v-else-if="filter.type === 'dropdown'">
            <label :for="filter.id" class="col-sm-6 col-form-label col-form-label-sm">{{ filter.label || $t(filter.id) }}</label>
            <dropdown-filter v-bind:filter="filter" @toggle-value="handleFilterChange" />
          </template>

          <template v-else-if="filter.type === 'customDropdown'">
            <label :for="filter.id" class="col-sm-6 col-form-label col-form-label-sm">{{ filter.label || $t(filter.id) }}</label>
            <custom-dropdown-filter v-bind:filter="filter" @toggle-value="handleFilterChange" />
          </template>

          <template v-else-if="filter.type === 'checkBox'">
            <label :for="filter.id" class="col-sm-6 col-form-label col-form-label-sm">{{ filter.label || $t(filter.id) }}</label>
            <check-box-filter v-bind:filter="filter" @toggle-value="handleFilterChange" />
          </template>

          <template v-else-if="filter.type === 'input'">
            <label :for="filter.id" class="col-sm-6 col-form-label col-form-label-sm">{{ filter.label || $t(filter.id) }}</label>
            <input-filter v-bind:filter="filter" @toggle-value="handleFilterChange" />
          </template>

          <template v-else>
            <label :for="filter.id" class="col-sm-6 col-form-label col-form-label-sm">{{ filter.label || $t(filter.id) }}</label>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangeFilter from '@/components/filter/DateRangeFilter.vue';
import DateFilter from '@/components/filter/DateFilter.vue';
import DropdownFilter from '@/components/filter/DropdownFilter.vue';
import CustomDropdownFilter from '@/components/filter/CustomDropdownFilter.vue';
import InputFilter from '@/components/filter/InputFilter.vue';
import CheckBoxFilter from '@/components/filter/CheckBoxFilter.vue';

var filterTimeout = null;

function calculateSliceValue(filterItemCount) {
  return Math.ceil(filterItemCount / 3);
}

export default {
  name: 'FilterOptions',
  props: ['filterItems', 'pageTitle'],
  components: {
    dateRangeFilter: DateRangeFilter,
    dateFilter: DateFilter,
    dropdownFilter: DropdownFilter,
    customDropdownFilter: CustomDropdownFilter,
    inputFilter: InputFilter,
    checkBoxFilter: CheckBoxFilter
  },
  data: function() {
    return {
      sliceValue: calculateSliceValue(this.filterItems.length),
      hasActiveFilters: false
    };
  },
  beforeMount() {
    this.hasActiveFilters = this.filterItems.some(item => {
      return item.value;
    });
  },
  methods: {
    handleFilterChange() {
      if (filterTimeout !== null) {
        clearTimeout(filterTimeout);
      }

      var self = this;

      filterTimeout = setTimeout(function() {
        self.$emit('filter-updated', self.filterItems);
        self.hasActiveFilters = self.filterItems.some(item => {
          return item.value;
        });
      }, 750);
    },
    resetAll: function() {
      this.hasActiveFilters = false;

      for (let i = 0; i < this.filterItems.length; i++) {
        this.filterItems[i].value = '';
      }
      this.$emit('filter-updated', this.filterItems);
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.5rem;
}
</style>
